<!-- 新版轻骑兵首页 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class="banner-con">
          <div class="banner-title">轻骑兵<div style="font-size: 20px;vertical-align: super;line-height: 20px">®</div>PaaS平台</div>
          <div class="banner-desc">
            创新驱动，共筑数字化未来！
            <!-- 视频 -->
            <img src="../assets/img/homePage/banner-start1.png" alt="播放" @click="startBannerVideo">
            <div class="banner-pulse1"></div>
            <div class="banner-pulse2"></div>
          </div>
          <div class="banner-btn">
            <div class="banner-btn-appointment" @click="openForm">预约体验</div>
            <div class="banner-btn-expert" @click="openForm">联系行业专家</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 通知 数字 -->
    <div class="notice-box">
      <div class="notice-con">
        <!-- 通知 -->
        <div class="notice-news">
          <img src="../assets/img/homePage/horn.png">
          <!-- 这是滚动的 后续可点击 -->
          <ul>
            <el-carousel direction="vertical" height="50px">
              <el-carousel-item>
                <li>轻骑兵低代码开发平台入选《 中国低代码/零代码市场发展洞察(2023年)》</li>
              </el-carousel-item>
              <el-carousel-item>
                <li>轻骑兵低代码开发平台首批通过中国信通院低代码平台标准评测!</li>
              </el-carousel-item>
              <el-carousel-item>
                <li>轻骑兵低代码开发平台入选《 中国低代码/零代码市场发展洞察(2023年)》</li>
              </el-carousel-item>
              <el-carousel-item>
                <li>轻骑兵低代码开发平台首批通过中国信通院低代码平台标准评测!</li>
              </el-carousel-item>
            </el-carousel>
          </ul>
        </div>
        <!-- 数字 -->
        <div class="notice-nums">
          <div>
            <img src="../assets/img/homePage/num1.png">
            <div>
              <span class="num">10000+</span>
              <span class="num-desc">交付案例</span>
            </div>
          </div>
          <div>
            <img src="../assets/img/homePage/num2.png">
            <div>
              <span class="num">200+</span>
              <span class="num-desc">开发组件</span>
            </div>
          </div>
          <div>
            <img src="../assets/img/homePage/num3.png">
            <div>
              <span class="num">40+</span>
              <span class="num-desc">世界500强企业客户</span>
            </div>
          </div>
          <div>
            <img src="../assets/img/homePage/num4.png">
            <div>
              <span class="num">20<span style="font-size: 24px;">年+</span></span>
              <span class="num-desc">信息化服务经验</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底座 -->
    <div class="model-box base-box">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>PaaS平台是企业数字化建设的底座
        </div>
      </div>
      <div class="model-desc">降低企业数字化转型难度，释放全员数字化创造活力</div>
      <div class="model-con base-con">
        <img class="model-con-img" src="../assets/img/homePage/firstpageProduct.gif">
      </div>
    </div>
<!--    &lt;!&ndash; 扩展性 &ndash;&gt;-->
<!--    <div class="model-box extend-box">-->
<!--      <div class="model-title">轻骑兵低代码开发平台具备很强的扩展性</div>-->
<!--      <div class="model-desc">提供多种二次开发方式，为复杂业务场景的开发提供支撑</div>-->
<!--      <div class="model-con extend-con">-->
<!--        <ExpendSwiper></ExpendSwiper>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 六大核心能力 -->
    <div class="model-box function-box">
      <div class="model-title">六大核心能力</div>
      <div class="model-con function-con">
        <el-tabs ref="handoffTab" :tab-position="tabPosition" v-model="funActiveName">
          <el-tab-pane name="first">
            <div class="el-tab-paneBox" slot="label" name="first">
              <div class="el-tab-paneBoxIcon1"></div>低代码开发
              <div class="el-tab-paneBoxLine"></div>
            </div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">AI低代码、低代码开发、高安全性、信创支持、高扩展性、二次开发、微服务</div>
              <div class="fun-tab-conImg fun-tab-conImg1">
<!--                <img src="../assets/img/homePage/function1.gif">-->
                <video src="../assets/video/didaima.mp4" class="intro-video" autoplay muted loop/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="零代码开发" name="second">
            <div class="el-tab-paneBox" slot="label" name="second"><div class="el-tab-paneBoxIcon2"></div>零代码开发<div class="el-tab-paneBoxLine"></div></div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">私有化部署、零低融合、零转低、高扩展性、国产化适配、对接原系统</div>
              <div class="fun-tab-conImg fun-tab-conImg2">
<!--                <img src="../assets/img/homePage/lingdaima.gif">-->
                <video src="../assets/video/lingdaima.mp4" class="intro-video" autoplay muted loop/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="融合集成" name="third">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="third"><div class="el-tab-paneBoxIcon3"></div>融合集成<div class="el-tab-paneBoxLine"></div></div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">可视化编排、服务持续集成、 信创要求、高安全性、深度运维监控 </div>
              <div class="fun-tab-conImg fun-tab-conImg3">
<!--                <img src="../assets/img/homePage/luojibianpai.gif">-->
                <video src="../assets/video/ronghejicheng.mp4" class="intro-video" autoplay muted loop/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作流平台" name="fourth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fourth"><div class="el-tab-paneBoxIcon4"></div>工作流平台<div class="el-tab-paneBoxLine"></div></div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">架构灵活、多租户、功能丰富、灵活的配置体系、多渠道消息推送、国产化适配</div>
              <div class="fun-tab-conImg fun-tab-conImg4">
<!--                <img src="../assets/img/homePage/gongzuoliu.gif">-->
                <video src="../assets/video/tongyiliucheng.mp4" class="intro-video" autoplay muted loop/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统一门户" name="fifth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fifth"><div class="el-tab-paneBoxIcon5"></div>统一门户<div class="el-tab-paneBoxLine"></div></div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">千人千面、信息中心、应用中心、统一权限、统一认证</div>
              <div class="fun-tab-conImg fun-tab-conImg5">
<!--                <img src="../assets/img/homePage/tongyimenhu.gif">-->
                <video src="../assets/video/tongyimenhu.mp4" class="intro-video" autoplay muted loop/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="智能服务基座" name="sixth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="sixth"><div class="el-tab-paneBoxIcon6"></div>智能服务基座<div class="el-tab-paneBoxLine"></div></div>
            <div class="fun-tab-con">
              <div class="fun-tab-conTitle">智能化全生命周期管理、开放性、可扩展性、安全高效</div>
              <div class="fun-tab-conImg fun-tab-conImg6"><img src="../assets/img/homePage/img6.gif" style="width: 99%"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 按钮 -->
      <div class="more-btn" @click="openForm">了解详情</div>
    </div>
    <!-- 核心价值 -->
    <div class="model-box value-box">
      <div class="model-title">核心价值</div>
      <div class="model-desc">助推研发效能提升，加速信息化建设进程 ，推进企业数字化转型</div>
      <div class="model-con value-con clearfix">
        <ul>
          <li class="value1" style="margin-right:55px;">
            <div>
              <img src="../assets/img/homePage/value1.png">
            </div>
            <div>
              <p class="value-title">低/零代码平台，革新研发范式，实现降本增效</p>
              <p class="value-desc">轻骑兵低/零代码开发平台助力企业优化研发流程，降低技术门槛，提升研发效率，在保证研发质量的同时缩短研发周期，实现企业的降本增效。</p>
            </div>
          </li>
          <li class="value2">
            <div>
              <img src="../assets/img/homePage/value2.png">
            </div>
            <div>
              <p class="value-title">融合集成平台，消除信息孤岛，强化协同效能</p>
              <p class="value-desc">轻骑兵融合集成平台凭借卓越的集成能力，实现跨系统、跨平台的数据整合。统一门户与流程的引入，消除信息壁垒，为企业的高效运作提供坚实支撑。</p>
            </div>
          </li>
          <li class="value3" style="margin-right:55px;">
            <div>
              <img src="../assets/img/homePage/value3.png">
            </div>
            <div>
              <p class="value-title">AI能力加持，智能驱动决策，促进数据融合</p>
              <p class="value-desc">轻骑兵具备AI能力，依托尖端智能分析与学习能力，为企业提供精准、高效的业务流程决策支持，助力企业实现由数字化向数智化的历史性跨越。</p>
            </div>
          </li>
          <li class="value4">
            <div>
              <img src="../assets/img/homePage/value4.png">
            </div>
            <div>
              <p class="value-title">可靠PaaS底座，稳固数字化基石，保障国产化战略实施</p>
              <p class="value-desc">轻骑兵PaaS平台作为一个可靠、稳定的低代码PaaS平台，全面适配国产化环境，作为企业研发底座，为数字化转型之路提供了坚实的技术保障。</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 按钮 -->
      <div class="value-btn" @click="openForm">预约体验</div>
    </div>
    <!-- 更多特性 -->
    <div class="model-box more-box">
      <div class="model-title">产品特性</div>
      <div class="model-con more-con clearfix">
        <div class="more-left">统一技术路线，沉淀技术资产，提升成果复用率</div>
        <div class="more-right">
          <ul class="clearfix">
            <li>
              <img src="../assets/img/homePage/more2.png">
              <span>多模式开发</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more12.png">
              <span>AI智能</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more4.png">
              <span>支持二次开发</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more7.png">
              <span>支持信创</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more11.png">
              <span>高安全性</span>
            </li>
          </ul>
          <ul class="clearfix">
            <li>
              <img src="../assets/img/homePage/more1.png">
              <span>单体/微服务架构</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more5.png">
              <span>原型即应用</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more6.png">
              <span>组件丰富</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more8.png">
              <span>多租户</span>
            </li>
            <li>
              <img src="../assets/img/homePage/more10.png">
              <span>模型/表单驱动</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <!-- 案例 -->
    <div class="model-box case-box" :style="{'background': 'url(' + caseBgList[caseBgIndex].img + ')'}">
      <div class="model-title">案例</div>
      <div class="model-desc">是客户也是伙伴，轻骑兵助力千行百业成功交付万余应用</div>
      <div class="model-con case-con">
        <CaseSwiper @changeBg="changeBg"></CaseSwiper>
        <div class="case-industry">
          <div class="case-industry-title">应用行业</div>
          <ul>
            <li>电力能源</li>
            <li>轨道交通</li>
            <li>航天军工</li>
            <li>石油石化</li>
            <li>智能制造</li>
            <li>冶金冶炼</li>
            <li>证券金融</li>
            <li>移动通信</li>
            <li>工程建筑</li>
            <li>政务服务</li>
            <li>产教融合</li>
            <li>商业服务</li>
          </ul>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="case-more-btn" @click="jumpTo('/CasePage')">了解更多<img src="../assets/img/homePage/case-more.png"></div>
    </div>
    <!-- 资质荣誉 -->
    <div class="model-box honor-box">
      <div class="model-title">资质荣誉</div>
      <div class="model-desc">科技创新是第一驱动力，我们坚持对产品、技术与服务的强投入</div>
      <div class="model-con honor-con">
        <div class="honor-num">
          <div>
            <div class="honor-item-num">
              <img src="../assets/img/homePage/honor-up.png">
              <span style="font-size: 30px;font-weight: bold;">第一个</span>
            </div>
            <div>低代码行业标准参编</div>
          </div>
          <div class="honor-num-item">
            <div class="honor-item-num">
              <img src="../assets/img/homePage/honor-up.png">
              <span>50<span>+</span></span>
            </div>
            <div>发明专利</div>
          </div>
          <div>
            <div class="honor-item-num">
              <img src="../assets/img/homePage/honor-up.png">
              <span>15<span>+</span></span>
            </div>
            <div>信创认证</div>
          </div>
          <div>
            <div class="honor-item-num">
              <img src="../assets/img/homePage/honor-up.png">
              <span>100<span>+</span></span>
            </div>
            <div>奖项</div>
          </div>
        </div>
        <div class="honor-list clearfix">
          <ul>
            <li>工信部“鼎信杯”信息技术应用创新优秀应用产品奖</li>
            <li>工信部信息技术应用创新工作委员会产品库入库产品</li>
            <li>工信部工业互联网APP优秀解决方案</li>
            <li>山东省重点研发计划（重大科技创新工程）项目</li>
            <li>“鲲鹏杯”山东新动能-软件创新创业大赛 企业组特等奖</li>
          </ul>
          <ul>
            <li>中国软件行业协会年度优秀软件产品</li>
            <li>中国行业信息化最佳产品</li>
            <li>中国软件技术最佳产品奖</li>
            <li>中国低代码年度明星产品奖</li>
            <li>山东省软件产业高质量发展重点项目</li>
          </ul>
        </div>
        <div class="honor-map"></div>
        <div class="honor-certificate">
          <img src="../assets/img/homePage/honor.png">
        </div>
        <!-- 按钮 -->
        <div class="more-btn" @click="openForm" style="margin-top: 36px;">预约体验</div>
      </div>
    </div>
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';
// import Footer from './include/Footer.vue';
import ExpendSwiper from './ExpendSwiper.vue';
import CaseSwiper from './CaseSwiper.vue';
import ContactExperts from './include/ContactExperts.vue';

const function21 = require('../assets/img/homePage/function21.gif');
const function22 = require('../assets/img/homePage/function22.gif');

export default {
  name: "HussarHomePage",
  data() {
    return {
      tabPosition:'left',
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false,
      funActiveName: 'first',
      funcSrc: function21,
      caseBgIndex: 0,
      caseBgList: [
        {
          img: require("../assets/img/homePage/case4-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case5-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case6-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case1-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case2-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case3-bg.jpg"),
        },
      ]
    };
  },
  components: {
    ContactExperts,
    Header,
    HussarForm,
    SideBar,
    // Footer,
    ExpendSwiper,
    CaseSwiper,
  },
  watch: {
    funActiveName(n) {
      if (n === 'second') {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 2000);
      }
    }
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 播放视频-banner处
    startBannerVideo() {
      const videoLink = window.location.protocol+ '//'+window.location.hostname+'/video/qqbxc.mp4';
      var $mask = $('<div class="dashboard-intro-mask"/>')
          .appendTo('body');
      var $wrapper = $('<div class="video-wrapper"/>').appendTo($mask);

      $('<video class="intro-video" autoplay controls ' +
          'src=' + videoLink + '/>')
          .appendTo($wrapper);
      $('<div class="close-btn"><img class="video-close" /></div>')
          .click(function () {
              $mask.remove();
              $('html').css('overflow-y', 'auto');
              $('.mobile .navbar-toggle.collapsed').css('display','block');
          })
          .appendTo($wrapper);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
    },
  },
  mounted() {
    // 视频播放
    var sUserAgent = navigator.userAgent;
    var phoneFlag = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1 || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1;
    if(phoneFlag ){
      document.getElementsByTagName('body')[0].classList.add('mobile')
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = oWidth/750*100 + "px";
    }
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/HussarHomePhonePage' });
    }
  },
  created() {},
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
/* banner */
.banner-bg{background: linear-gradient(to right, #D5E2EF 0%, #D5E2EF 50%, #CFE1EF 50%, #CFE1EF 100%);}
.banner-box {width: 100%;height: 630px;background: url('../assets/img/homePage/banner-gif.gif'), url('../assets/img/homePage/banner-bg.png'); background-position: 50%;background-repeat: no-repeat;}
.banner-con {width: 1200px;margin: 0 auto;padding-top: 205px;}
.banner-title {font-size: 50px;font-weight: bold;line-height: 70px;display: flex}
.banner-desc {display: flex;align-items: center;position: relative;height: 40px;font-size: 28px;font-weight: 400;line-height: 40px;}
.banner-desc img {margin-left: 6px;z-index: 2;width: 45px}
.banner-desc img:hover {transform: scale(1.2);}
.banner-pulse1 {
  position: absolute;left: 370px;top: -2px;
  width: 45px;
  height: 45px;
  border: 2px solid #FFF;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  animation: warn1 2s linear 1s infinite;
  box-shadow: 2px 2px 30px #FFF;
}
.banner-pulse2 {
  position: absolute;left: 370px;top: -2px;
  width: 45px;
  height: 45px;
  border: 2px solid #FFF;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  animation: warn1 2s linear 1.5s infinite;
  box-shadow: 2px 2px 30px #FFF;
}
.banner-btn {position: relative;margin-top: 54px;cursor: pointer;}
.banner-btn-appointment {
  display: inline-block;
  width: 158px;
  height: 54px;
  background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
  border-radius: 5px;
  color: #FFF;
  font-size: 18px;
  text-align: center;
  line-height: 54px;
}
.banner-btn-appointment:hover {background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);}
.banner-btn-expert {
  display: inline-block;
  width: 158px;
  height: 54px;
  margin-left: 13px;
  border: 1px solid #1D79FB;
  border-radius: 5px;
  line-height: 54px;
  color: #1D79FB;
  font-size: 18px;
  text-align: center;
}
.banner-btn-expert:hover {background: rgba(29, 121, 251, 0.1);}
/* 通知 */
.notice-box {position: relative;width: 100%;height: 128px;}
.notice-con {position: absolute;top: -74px;left: 50%;width: 1200px;transform: translateX(-50%);}
.notice-news {
  background: linear-gradient(90deg, rgba(29, 121, 251, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  border-radius: 5px;
}
.notice-news >>> .el-carousel__indicators {display: none;}
.notice-news img {float: left;margin: 13px 14px 12px 24px;}
.notice-nums {
  display: flex;
  justify-content: space-around;
  height: 152px;
  background: #FFF;
  box-shadow: 0px 3px 10px 1px rgba(4,50,130,0.1);
  border-radius: 5px;}
.notice-nums > div {display: flex;align-items: center;}
.notice-nums > div > div {display: flex;flex-direction: column;margin-left: 8px;}
.notice-nums .num {font-size: 38px;font-family: SWIS;}
.notice-nums .num-desc {font-size: 18px;}
/* 标题样式 */
.model-box {position: relative;width: 100%;padding: 80px 0 100px 0;}
.model-con {width: 1200px;margin: 0 auto;position: relative;}
.model-con-img {width: 1119px;height: 749px;padding-left: 40px;}
.model-title {font-size: 34px;font-weight: bold;text-align: center;line-height: 52px;}
.model-desc {font-size: 22px;text-align: center;line-height: 60px;height: 43px;}

/* 底座内容 */
.base-circle {
  position: absolute;
  width: 570px;
  height: 570px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background: rgba(201,225,255, 0.1);
  z-index: -1;
}
.base-img {display: flex;margin-top: 64px;}
.base-arrow {margin: 0 75px 0 51px;}
.base-right {display: inline-block;width: 317px;}
.base-right > div {
  position: relative;
  display: flex;
  align-items: center;
  height: 84px;
  padding-left: 75px;
  margin-bottom: 30px;
  font-size: 18px;
  box-shadow: 0px 0px 10px 1px rgba(27,86,228,0.15);
  border-radius: 8px;
}
.base-right > div img {position: absolute;left: -31px;}
.base-right > div .base-key-word {color: #186CF5;margin-right: 8px;}
/* 扩展性 */
.extend-con {width: 1186px;height: 722px;padding-top: 56px;margin-bottom: 76px;}
/* 主要功能 */
.function-box {height: 918px;background: #F1F5FB;}
.function-con {height: 653px;padding-top: 52px;}
/*.function-con >>> .el-tabs,*/
/*.function-con >>> .el-tab-pane,*/
.fun-tab-con {width: 885px;height: 609px;border-radius: 4px 4px 4px 4px;opacity: 1;padding-top: 20px;}
.function-con >>> .el-tabs__content {height: calc(100% - 126px);}
.function-con >>> .el-tabs__header {margin-bottom: 68px;margin-right: unset!important;}
.function-con >>> .el-tabs__nav-wrap::after {display: none;}
.function-con >>> .el-tabs__active-bar {display: none;}
.function-con >>> .el-tabs__nav {width: 100%;text-align: center;}
.function-con >>> .el-tabs__item {
  width: 282px;
  height: 70px;
  padding: 0;
  margin: 38px 30px 0 0;
  line-height: 58px;
  text-align: center;
  font-size: 20px;
  color: #333;
  background: #FFF;
  border-radius: 2px;
}
.el-tab-paneBox {display: flex;align-items: center;justify-content: center;height: 100%;width: 100%;position: relative;}
.el-tab-paneBoxPad {padding-right: 20px;}
.el-tab-paneBoxLine {width: 3px;height: 70px;background: #0D83FA;border-radius: 0px 0px 0px 0px;opacity: 1;position: absolute;right: -30px;display: none;}
.is-active .el-tab-paneBoxLine {display: block;}
.el-tab-paneBoxIcon1 {width: 33px;height: 40px;background: url("../assets/img/homePage/01.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.el-tab-paneBoxIcon2 {width: 33px;height: 40px;background: url("../assets/img/homePage/02.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.el-tab-paneBoxIcon3 {width: 33px;height: 40px;background: url("../assets/img/homePage/03.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.el-tab-paneBoxIcon4 {width: 33px;height: 40px;background: url("../assets/img/homePage/04.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.el-tab-paneBoxIcon5 {width: 33px;height: 40px;background: url("../assets/img/homePage/05.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.el-tab-paneBoxIcon6 {width: 33px;height: 40px;background: url("../assets/img/homePage/06.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> #tab-0 {margin-top: 0;}
.function-con >>> #tab-first {margin-top: 0;}
.function-con >>> .el-tabs__item.is-active {color: #FFF;background: url("../assets/img/homePage/buttonback.png") no-repeat;background-size: 110% 160%;background-position: 50%;background-color: #0D83FA;}
.function-con >>> .is-active .el-tab-paneBoxIcon1 {width: 33px;height: 40px;background: url("../assets/img/homePage/001.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .is-active .el-tab-paneBoxIcon2 {width: 33px;height: 40px;background: url("../assets/img/homePage/002.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .is-active .el-tab-paneBoxIcon3 {width: 33px;height: 40px;background: url("../assets/img/homePage/003.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .is-active .el-tab-paneBoxIcon4 {width: 33px;height: 40px;background: url("../assets/img/homePage/004.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .is-active .el-tab-paneBoxIcon5 {width: 33px;height: 40px;background: url("../assets/img/homePage/005.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .is-active .el-tab-paneBoxIcon6 {width: 33px;height: 40px;background: url("../assets/img/homePage/006.png") no-repeat;background-size: 100% 100%;margin-right: 20px;}
.function-con >>> .fun-tab-conTitle {text-align: center;width: 100%;height: 22px;font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #2E2E2E;line-height: 22px;}
.function-con >>> .fun-tab-conImg {width: 875px;height: 522px;margin: 15px;}
.fun-tab-conImg img{box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
.fun-tab-conImg video{width: 100%;box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
/*.function-con >>> .fun-tab-conImg > img {width: 100%;height: 100%;}*/
/*.function-con >>> .fun-tab-conImg1 {background: url("../assets/img/homePage/function1.gif") no-repeat;background-size: 100% 100%;}*/
/*.function-con >>> .fun-tab-conImg2 {background: url("../assets/img/homePage/lingdaima.gif") no-repeat;background-size: 100% 100%;}*/
/*.function-con >>> .fun-tab-conImg3 {background: url("../assets/img/homePage/luojibianpai.gif") no-repeat;background-size: 100% 100%;}*/
/*.function-con >>> .fun-tab-conImg4 {background: url("../assets/img/homePage/gongzuoliu.gif") no-repeat;background-size: 100% 100%;}*/
/*.function-con >>> .fun-tab-conImg5 {background: url("../assets/img/homePage/tongyimenhu.gif") no-repeat;background-size: 100% 100%;}*/
/*.function-con >>> .fun-tab-conImg6 {background: url("../assets/img/homePage/img6.gif") no-repeat;background-size: 100% 100%;}*/
.home .el-tabs--left .el-tabs__header.is-left {margin-right: 0;}
.tab-left {width: 366px;float: left;position: relative;padding-right: 44px;}
.left-title {margin: 12px 0 58px;font-size: 28px;font-weight: bold;color: #333;line-height: 40px;}
.tab-left ul {font-size: 14px;line-height: 31px;}
/* .tab-left ul li {display: flex;align-items: baseline;justify-content: flex-start;} */
.tab-left ul li span {display: block;float: left;width: calc(100% - 24px);}
.tab-left ul li span.fun-li-circle {display: block;width: 14px;height: 14px;margin-right: 10px;position: relative;
  top: 9px;background: linear-gradient(180deg, #2377FF 0%, #BDD6FF 100%);border-radius: 50%;}
.fun-btn {width: 110px;height: 38px;margin: 21px auto 0;background: #186CF5;border-radius: 5px;line-height: 38px;color: #fff;font-size: 16px;text-align: center;cursor: pointer;}
.fun-btn1 {margin-top: 48px;}
.fun-btn:hover {background: rgba(21, 132, 243, 0.9);}
.tab-right {width: calc(100% - 366px);float: left;text-align: center;}
.tab-right img.boxshadow {box-shadow: 0 3px 10px 1px rgba(0, 0, 0, .16);}
/* 核心价值 */
.value-box {height: 722px;background-image: url("../assets/img/homePage/hexin-bg.png"); color: #FFF;}
.value-con {padding-top: 60px;font-size: 16px;color: #2E2E2E;line-height: 31px;}
.value-con ul li {width: 570px;height: 160px;float: left;margin-bottom: 48px;border-radius: 5px;background-repeat: no-repeat;color: #ffffff}
.value-con ul li div{float: left;height: 100%}
.value-con ul li div img{margin: 40px 10px 40px 0px;}
.value-con ul li div:nth-child(2){width: 84%;background: #2D6EEB;border-radius: 5px;padding: 20px 5px 10px 20px}
.value-con ul li:nth-child(3n) {margin-right: 0;}
.value-con ul li p.value-title {font-size: 18px;font-weight: bold;margin-bottom: 10px}
.value-con ul li p.value-desc {font-size: 14px;color: #EEEEEE}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);
  width: 110px;height: 38px;
  background: #FFF;border-radius: 5px;
  font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;
}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}
/* 更多产品特性 */
.more-con {height: 408px;padding-top: 48px;}
.more-left {width: 328px;height: 310px;float: left;margin-right: 24px;padding: 40px 25px 0 22px;
background: url('../assets/img/homePage/more-left.png');font-size: 20px;line-height: 36px;}
.more-right {width: 848px;height: 310px;box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);border-radius: 5px;float: left;}
.more-right ul {height: 155px;}
.more-right ul li {float: left;width: 168px;height: 100%;position: relative;
  text-align: center;
  line-height: 155px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;cursor: context-menu;}
.more-right ul li:hover {color: #186CF5;}
.more-right ul li::after {width: 1px; height: 108px; background: rgba(112, 112, 112, 0.1);display: block;content: '';right: 0;position: absolute;bottom: 0;}
.more-right ul li:last-child::after {display: none;}
.more-right ul li span {margin-top: 15px;line-height: 22px;font-size: 16px;}
.more-right ul:last-child li::after {top: 0;}
.more-right ul:last-child li::before {width: 100%; height: 1px; background: rgba(112, 112, 112, 0.1);display: block;content: '';right: 0;position: absolute;top: 0;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);
  width: 110px;height: 38px;
  background: #186CF5;border-radius: 5px;
  font-size: 16px;text-align: center;color: #FFF;line-height: 38px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
/* 案例 */
.case-box {height: 800px;transition: background 1s ease;background-repeat: no-repeat !important; background-size: cover !important;}
.case-box .model-title, .case-box .model-desc {color: #FFF;}
.case-con {display: flex;margin-top: 54px;margin-bottom: 40px;}
.case-industry {background: url('../assets/img/homePage/case-industry-bg.png');width: 275px;height: 428px;padding: 16px 39px 0 32px;color: #FFF;}
.case-industry-title {font-size: 20px;font-weight: bold;line-height: 52px;border-bottom: 1px solid #FFF;}
.case-industry ul li {float: left;margin-top: 32px;width: 64px;margin-right: 56px;font-size: 16px;}
.case-industry ul li:nth-child(2n) {margin-right: 0;}
.case-more-btn {background: linear-gradient(90deg, #1A74F1 0%, #018DFF  100%);
  position: relative;left: 50%;transform: translateX(-50%);width: 105px;height: 44px;
  border-radius: 5px;font-size: 14px;text-align: center;color: #FFF;line-height: 44px;cursor: pointer;
}
.case-more-btn img {margin-left: 3px;transition: all .3s ease;}
.case-more-btn:hover img {transform: translateX(8px);}
/* 资质荣誉 */
.honor-box {height: 1055px;background: linear-gradient(180deg, #ECF6FF 0%, #FFF 100%);}
.honor-num {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 125px;
  margin-top: 53px;
  margin-bottom: 79px;
  background: #FFF;
  font-size: 18px;
  border-radius: 5px;
  box-shadow: 0px 3px 10px 1px rgba(4, 50, 130, 0.09);
}
.honor-item-num {margin-bottom: 5px;font-size: 0;}
.honor-item-num img {position: relative;top: 4px;margin-right: 9px;}
.honor-item-num > span {font-size: 38px;font-family: SWIS;}
.honor-item-num > span > span {font-size: 24px;}
.honor-list {font-size: 16px;line-height: 31px;}
.honor-list ul {float: left;width: 489px;}
.honor-list ul:first-child {margin: 0 124px 0 98px;}
.honor-map {
  position: absolute;
  width: 487px;
  height: 344px;
  top: 128px;
  left: 50%;
  transform: translateX(-50%);
  background: url('../assets/img/homePage/honor-map.png');
  opacity: 0.54;
}
.honor-certificate {margin-top: 80px;}
/* 联系专家 */
.contact-box {
  height: 399px;
  background: url('../assets/img/homePage/contact-bg.png') no-repeat;
  background-size: cover;
}
.contact-con {width: 1200px;margin: 0 auto;position: relative;font-size: 16px;}
.contact-left {position: relative;float: left;width: 320px;margin-top: 112px;}
.contact-left > div {margin-bottom: 22px;}
.contact-left ul {display: inline-block;margin-left: 20px;color: #186CF5;line-height: 32px;position: relative;top: -3px;}
.contact-left ul img {margin-right: 5px;}
.contact-right {float: right;width: 344px;color: #FFF;margin-top: 46px;}
.contact-right .contact-img {background: url('../assets/img/homePage/hussar.webp');width: 394px;height: 410px;transform: scale(0.8);position: absolute;left: 33%;top: 0;}
.contact-right > div {margin-bottom: 20px;}
.contact-right >>> .el-form-item {margin-bottom: 12px;}
.contact-right >>> .el-form-item__content {line-height: 44px;}
.contact-right >>> .el-input__inner {height: 44px;line-height: 44px;background: rgba(255,225,255, 0.28);border: none;color: #FFF;}
.contact-right >>> .el-input__inner::placeholder {color: #FFF;}
.contact-right >>> .el-autocomplete {width: 100%;}
.contact-right >>> .el-form-item.is-error .el-input__inner {border: 1px solid #F56C6C;}
/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
</style>
<style>
/* 视频播放层样式 */
.dashboard-intro-mask {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color:transparent;
  overflow:hidden;
  -webkit-transition:background-color opacity;
  transition:background-color opacity;
  -webkit-transition-duration:218ms;
  transition-duration:218ms;
  background-color:rgba(0, 0, 0, .25);
  z-index:999
}
.dashboard-intro-mask .video-wrapper {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  margin:auto;
  height:562px;
  max-width:1000px
}
.dashboard-intro-mask .video-wrapper .intro-video {
  width:100%
}
/* 视频关闭按钮 */
.dashboard-intro-mask .video-wrapper .close-btn {
  position:absolute;
  top:10px;
  right:10px;
  width:32px;
  height:32px;
  border-radius:6px;
  background: rgba(0,0,0,0.5);
  cursor:pointer;
  background: url('../assets/img/close.png');
}
/* banner视频播放按钮 动画 */
@keyframes warn1 {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0.0;
  }
  25% {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    opacity: 0.1;
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    opacity: 0.3;
  }
  75% {
    transform: scale(1.5);
    -webkit-transform: scale(1.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.8);
    -webkit-transform: scale(1.8);
    opacity: 0.0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HussarHomePage.vue